import { render, staticRenderFns } from "./FormItemCanBreak.vue?vue&type=template&id=247df380"
import script from "./FormItemCanBreak.vue?vue&type=script&lang=js"
export * from "./FormItemCanBreak.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports